import { Link, useSearchParams } from 'react-router-dom';
import { XCircle } from 'lucide-react';

export default function PaymentCancelledPage() {
  const [params] = useSearchParams();
  const orderId = params.get('order_id') || '';

  return (
    <div data-testid="payment-cancelled-page" className="pt-28 pb-24 min-h-screen flex items-center justify-center">
      <div className="text-center max-w-md px-4">
        <XCircle size={56} className="mx-auto mb-6" style={{ color: '#B80000' }} />
        <h1 className="font-serif text-5xl font-light mb-4" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
          Paiement Annulé
        </h1>
        {orderId && (
          <p className="text-xs uppercase tracking-[0.2em] font-bold text-black/40 mb-4">
            Commande #{orderId}
          </p>
        )}
        <p className="text-sm text-black/60 mb-10">
          Votre paiement n'a pas abouti. Aucun montant n'a été débité. Vous pouvez réessayer depuis votre panier.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/cart" className="btn-primary inline-block">Retour au Panier</Link>
          <Link to="/shop" className="btn-secondary inline-block">Continuer les Achats</Link>
        </div>
      </div>
    </div>
  );
}
